import React, { useEffect, useState, Fragment, useRef } from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Box } from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

    render() {
        const tableData = this.props.data;
        const searchData = this.props.searchData;
        const finalTotalVal = this.props.finalTotalVal;
        const finalTotalOverkiloVal = this.props.finalTotalOverkiloVal;
        const dateList = this.props.dateList;

        return (
            <div>
                <h3><center><u>Green Leaf Report With Over KG Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Gang: </b> {searchData.gang}</div>
                    <div className="col"><b>Month: </b> {searchData.month}</div>
                </div>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <TableContainer>
                        <Table >
                            <TableHead>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>EMP No</TableCell>
                                    <TableCell align="center" colSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Total</TableCell>
                                </TableRow>
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Total Kilos (Kg)</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", fontSize: '11px' }}>Over Kilos (Kg)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map(item => {
                                    let totalKillo = 0;
                                    let totalOverKilo = 0;
                                    return (
                                        <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                            <TableCell key={item.registrationNumber} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                            {dateList.map(x => {
                                                const res = item.list.filter(y => parseInt(y.cardReadTime.slice(8, 10)) == parseInt(x))
                                                if (res.length > 0) {
                                                    totalKillo += res[0].totalAmount;
                                                    if (res[0].totalAmount > res[0].configurationValue) {
                                                        totalOverKilo = totalOverKilo + (res[0].totalAmount - res[0].configurationValue);
                                                    }
                                                }
                                            })}
                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalKillo)}</TableCell>
                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalOverKilo)}</TableCell>
                                        </TableRow >
                                    )
                                })}
                                <TableRow style={{ border: "2px solid black" }}>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >Total</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} > {finalTotalVal}</TableCell>
                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} > {finalTotalOverkiloVal}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
        );
    }
}